import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvTaskTypes } from "../_loadingHelpers/EvTask";
import { DOMhelpers, EntityHelpers, FeatureHelpers, ToasterHelpers } from "../../more/Helpers";
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import { AddressTypes } from "../_loadingHelpers/Address";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';


interface EvTaskWithRegistrations extends EvTask {
    EL_ht_ev_task_possible_executor_ev_task: Array<{
        ref_address: AddressTypes.AddressEntity_Base
    } & more.EntityAPIResultExtended>        
}


interface EvTaskTypeAddressesRegistryEntry { taskType: EvTaskDescript, addresses: AddressTypes.AddressEntity_Base[] }
class EvTaskAssignmentAgenda extends compose(AgendaViewBase<EvTask>, _TabEnabledMixin) {
    //templateString = template; // Standard verwenden...


    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private tableFormatterHeadings(originalHeading: string, colName: string) {

        switch (colName) {
            case "assignmentStatus":

                let icon = DOMhelpers.createFontawesomeIcon("far fa-check-circle");
                return icon;


                break;

            default:
                return false;
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<EvTask>) {
        let node = cell.contentnode;
        let entity = cell.entity as EvTaskWithRegistrations;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {
            case "assignmentStatus":

                let employeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;
                let icon = DOMhelpers.createFontawesomeIcon("far fa-check-circle");
                
                switch (value as number) {
                    case -2:
                        icon = DOMhelpers.createFontawesomeIcon("fas fa-user-check w3-text-blue");
                        break;
                    default:
                    
                    case -1:
                        icon = DOMhelpers.createFontawesomeIcon("far fa-circle warningTXT");
                        break;

                    case 0:
                        icon = DOMhelpers.createFontawesomeIcon("fas fa-exclamation-triangle w3-text-orange");
                        break;

                    case 1:
                        icon = DOMhelpers.createFontawesomeIcon("fas fa-check-circle successTXT");
                        break;
                }

                return icon;

                break;

            case "employee":
                if (this._selectableEmployeesRegistry && this.hasUserRole("EvTask_EmployeeAssignment")) {

                    let addresses = [];
                    if (FeatureHelpers.hasFeature("EvTask/RegistrationAgenda") && typeof (entity.EL_ht_ev_task_possible_executor_ev_task) != "undefined") {

                        entity.EL_ht_ev_task_possible_executor_ev_task.forEach(entry => {
                            entry.ref_address.Classname = entry.Classname;
                            entry.ref_address.ClassPrintname = entry.ClassPrintname;
                            addresses.push(entry.ref_address);
                        })
                    }

                    let taskType = entity?.ref_task_description;
                    if (taskType) {
                        let regEntry = this._selectableEmployeesRegistry[taskType.ID];

                        if (regEntry) {
                            addresses = addresses.concat(regEntry.addresses);
                        } 
                    }

                    if (addresses.length) {
                        let input = new SearchSelect();
                        input.hideBtnShowSelected(true);
                        input.setData(
                            entity.ref_vt_address_backoffice,
                            addresses, true,
                            "gDisp_Name_Firstname",
                            "ID",
                            null,
                            "ClassPrintname",
                            "Classname"
                        );

                        input.placeAt(node, "only");
                        input.on("change", lang.hitch(this, this._onChangedAssignedEmployee, cell))
                        return true;
                    }
                    
                }
                return false;
                break;
            //default:
            //    node.innerHTML = value;
            //    return true;
        }

        return false;
    }

    private _onChangedAssignedEmployee(cell: StaticTable.StaticTableCell<EvTask>, newValue) {
        let entity = cell.entity;
        
        if (typeof (newValue) == "string" || newValue === null) {
            this._saveEmployeeAssignment(cell, newValue);
        }
    }

    private _saveEmployeeAssignment(cell: StaticTable.StaticTableCell<EvTask>, employeeID: string) {
        let taskID = cell.entity.ID;

        let data = {
            evTaskID: taskID,
            employeeID: employeeID
        };

        ToasterHelpers.removeToast("saveassignment-" + taskID);

        this.StandbyStart(cell.tableRow.node, taskID);

        this.RequestManager.callfunction(
            "Webtool_API_EvTask_EmployeeAssignmentAgenda___SaveEmployeeAssignment",
            data,
            lang.hitch(this, this._onSavedEmployeeAssignment, true, cell),
            lang.hitch(this, this._onSavedEmployeeAssignment, false, cell)
        );
    }

    private _onSavedEmployeeAssignment(success: boolean, cell: StaticTable.StaticTableCell<EvTask>, response) {
        let taskID = cell.entity.ID;

        this.StandbyStop(taskID);

        if (success != true) {
            let error = response as more.requestErrorMessage;
            console.error(error.Message);
            ToasterHelpers.showError(error, "could not save employee assignment", "saveassignment-" + taskID);
        } else {
            ToasterHelpers.showSaved();
            let data = response as EvTask;
            if (typeof (data) == "object" && data) {
                this.agendaView.resultTable.updateEntity(data);
            }
        }
    }

    onLoadedData() {
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
        //    this.createContextButton({
        //        label: "??",
        //        callback: lang.hitch(this, this._onClick_Context),
        //        placement: "top",
        //        /*iconClass: "fas fa-calendar-times",*/
        //        permanent: false
        //    });
    }


    private _onClick_Row(row: StaticTable.StaticTableRow<EvTaskTypes.EvTaskListData>) {
        let entity = row.entity;

        let view: MdsLax<InstanceType<typeof _EntityViewMixin>>;
        EntityHelpers.openEntityView({
            entityClass: entity.Classname,
            entityId: entity.ID,
            label: entity.gDisp_1,
            contextName: "EmployeeAssignmentAgenda"
        }, { openCallback: lang.hitch(this, this._onOpenView), changedCallback: lang.hitch(this, this._onChangeEntity) });
    }

    private _onOpenView(view: MdsLax<InstanceType<typeof _EntityViewMixin>>) {
        // falls wir das Entityviewwidget brauchen....
        console.debug("view opened", view);
    }
    private _onChangeEntity() {
        this.loadData();
    }

    private _selectableEmployeesRegistry: Record<string, EvTaskTypeAddressesRegistryEntry>;

    private _onTableExpander_ExpanderClick(state: boolean, container: HTMLElement, rowGroup: StaticTable.StaticTableRowGroup<EvTask>) {
        // jetzt in den Container das Dropdown mit den möglichen Mitarbeitern für diesen Diensttyp
        let task = rowGroup.entity;
        let taskTypeID = task.ref_task_description.ID;

        let entry = this._selectableEmployeesRegistry[taskTypeID];
        

    }

    private _onTableExpander_Setup(rowGroup: StaticTable.StaticTableRowGroup<EvTask>): HTMLElement {
        let container = this.UiModder.domConstruct.create("div", {
            className: ""
        });


        return container;
    }

    private _loadSelectableEmployeesRegistry() {
        ToasterHelpers.removeToast("registryLoad");

        if (!this.hasUserRole("EvTask_EmployeeAssignment")) return;

        let data = {

        };

        this.StandbyStart(null, "registry");

        this.RequestManager.callfunction(
            "Webtool_API_EvTask_EmployeeAssignmentAgenda___LoadSelectableEmployeesRegistry",
            data,
            lang.hitch(this, this._onLoadSelectableEmployeesResponse, true),
            lang.hitch(this, this._onLoadSelectableEmployeesResponse, false)
        );
    }

    private _onLoadSelectableEmployeesResponse(success: boolean, response) {
        this.StandbyStop("registry");   

        if (success != true) {
            let error = response as more.requestErrorMessage;
            console.error(error.Message);
            ToasterHelpers.showError(error, "could not load selectable employees", "registryLoad");
        } else {
            let data = response as EvTaskTypeAddressesRegistryEntry[];

            this._selectableEmployeesRegistry = {};
            for (let entry of data) {
                this._selectableEmployeesRegistry[entry.taskType.ID] = entry;
            }

            this.redrawTable(); // falls vorher fertig

        }
    }
    
    private startAgenda(hasPrivilege: boolean) {
        // war nur ein dummy-Recht, so streng muss es nicht sein
        //if (!hasPrivilege) {
        //    this.destroy();
        //    return;
        //}

        this._loadSelectableEmployeesRegistry();
        
        this.setupAgendaView({
            configCallfunction: "Webtool_API_EvTask_EmployeeAssignmentAgenda__GetAgendaFilterOptionsJSON",
            filterdataCallfunction: "Webtool_API_EvTask_EmployeeAssignmentAgenda__GetAgendaResultListJSON",
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.tableFormatter),
            tableHeaderFormatterFunction: lang.hitch(this, this.tableFormatterHeadings),
            //showAppointmentLabels: true
            //tableRowExpanderConfig: {
            //    contentSetupCallback: lang.hitch(this, this._onTableExpander_Setup),
            //    expandClickCallback: lang.hitch(this, this._onTableExpander_ExpanderClick)
            //}
        });
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";
        this.useStandbyManager = true;

        this.hasUserRole("-dummy-", lang.hitch(this, this.startAgenda));
    }
    
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskAssignmentAgenda);